import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  timeout: 25000
  // withCredentials: true // send cookies when cross-domain requests
})
declare module 'axios' {
  interface AxiosInstance {
    (config: AxiosRequestConfig): Promise<any>
  }
}
// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (UserModule.token) {
      // config.headers['X-Access-Token'] = UserModule.token
      // config.headers.Authorization = `Bearer ${UserModule.token}`
      // config.headers.systemCode = UserModule.systemCode
    }
    if (document.cookie) {
      document.cookie.split(';').forEach((item) => {
        if (item.startsWith(' token=')) {
          console.log(item)
          config.headers.Authorization = item.slice(7)
        }
      })
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// Response interceptors
service.interceptors.response.use(
  (response:any) => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    // code == 50002: already login in other place
    // code == 50003: access token expired
    // code == 50004: invalid user (user not exist)
    // code == 50005: username or password is incorrect
    // You can change this part for your own usage.

    const res = response.data
    // if (response.config) {
    //   if (response.config.url.indexOf('sfcservice') > -1) {
    //     setReqCookie(response.headers.Cookie)
    //   }
    // }
    if (res.code !== '000000') {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          '你已被登出，可以取消继续留在该页面，或者重新登录',
          '确定登出',
          {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }
        ).then(() => {
          UserModule.ResetToken()
          location.reload() // To prevent bugs from vue-router
        })
      }
      console.log(res, 'err')
      if (res.code === '400000') {
        // window.location.href = 'https://www.sfcservice.com/login'
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response.data
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
